import apiHelper from "../apiHelper";

// ERP-5249 — GET an endpoint that answers with a file and hand it to the browser.
//
// The three Platform Pricing download buttons (Export template, Validation
// Result, Sync Report) each had their own copy of this; openpyxl sends the real
// name in Content-Disposition, so the fallback only matters when a proxy strips
// the header. Returns true when the file was delivered.
export default async function downloadXlsx(path, fallbackName) {
  const res = await apiHelper(path, "GET");
  if (!res || !res.ok) return false;
  const blob = await res.blob();
  const disposition = res.headers && res.headers.get ? res.headers.get("Content-Disposition") : null;
  const match = disposition && /filename="?([^";]+)"?/.exec(disposition);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = match ? match[1] : fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
  return true;
}
